import { createContext, useContext, PropsWithChildren, useMemo } from 'react';

import createLaunchDarklyClient, {
  LaunchDarklyClient,
} from 'studio5/clients/launch-darkly';

const LaunchDarklyContext = createContext<LaunchDarklyClient>(
  {} as LaunchDarklyClient
);

export default function FeatureFlagsProvider({
  children,
}: PropsWithChildren<unknown>) {
  const launchDarklyClient = useMemo(() => {
    return createLaunchDarklyClient();
  }, []);

  return (
    <LaunchDarklyContext.Provider value={launchDarklyClient}>
      {children}
    </LaunchDarklyContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(LaunchDarklyContext);
}
